//task-day-sow-section.tsx

import { Box, Typography } from "@mui/material";
import TaskGrid from "../task-grid";
import { SowTaskRow } from "../../types/task-rows";
import { Tasks } from "../../models/tasks";
import { GridColDef } from "@mui/x-data-grid";

type ColumnOption = {
  field: string;
  label: string;
};

interface TasksDaySowSectionProps {
  rows: SowTaskRow[];
  sowColumns: GridColDef[];
  sowColumnOptions: ColumnOption[];
  periodTasksTag?: number;
  title: string;

  periodTasks: Tasks[]; // same pattern as Soak — use raw tasks for tray total
}

export default function TasksDaySowSection({
  rows,
  sowColumns,
  sowColumnOptions,
  periodTasksTag,
  periodTasks,
  title,
}: TasksDaySowSectionProps) {
  // ✅ Use original logic: sum int trays from backend (already rounded up)
  const trayTotal = periodTasks[0].sow.reduce((sum, t) => sum + t.trays, 0);

  return (
    <Box>
      {/* ----- HEADER (same style as TaskHeader) ----- */}
      <Typography
        variant="h4"
        color="primary"
        sx={{
          pt: 4,
          display: "flex",
          alignItems: "end",
          justifyContent: "space-between",
        }}
      >
        {title}
        {rows.length > 0 && (
          <Typography sx={{ float: "right" }} color="black" variant="body1">
            <strong>Trays to Sow Total: {trayTotal}</strong>
          </Typography>
        )}
      </Typography>

      {/* ----- GRID ----- */}
      <TaskGrid
        key={periodTasksTag}
        taskKey="sow"
        rows={rows}
        baseColumns={sowColumns}
        columnOptions={sowColumnOptions}
        rowClassName={(params) => {
          const { batchNumber, isPastDue } = params.row;

          // overdue always wins (red background)
          if (isPastDue) return "row-overdue";

          // normal batch coloring
          if (batchNumber)
            return `batch-${batchNumber.replace(/[^a-zA-Z0-9]/g, "_")}`;

          return "";
        }}
      />
    </Box>
  );
}
